export const environment = {
  production: true,
  // apiUrl: 'http://appdev:5558/api/', // cert
  apiUrl: 'https://ecrm.prototechnika.lt:8443/api/', // cert
  // apiUrl: 'http://appdev:5568/api/', // nocert
  // dpaServiceUrl: 'http://appdev:3200/'
  dpaServiceUrl: 'https://ecrm.prototechnika.lt:2100/',
  commitHash: 'COMMIT_HASH_PLACEHOLDER'
};
